import { Card } from "@/components/ui/card";
import { num } from "./meta";

function DayStatus({ d }) {
  if (d.error) return <span className="text-rose-700" title={d.error}>Failed — {d.error}</span>;
  if (d.missing_files?.length) return <span className="text-amber-700">WebCDR file missing for {d.missing_files.join(", ")}</span>;
  return <span className="text-emerald-700">OK</span>;
}

/** Per-day result of the collection step. */
export function RunDays({ days, checkOnly }) {
  return (
    <Card className="overflow-hidden border-slate-200 shadow-sm" data-testid="uc-run-days">
      <div className="border-b border-slate-100 px-5 py-3">
        <h3 className="font-heading text-sm font-semibold text-slate-800">Calls collected from WebCDR</h3>
        <p className="text-[11px] text-slate-500">A UTC day spans two WebCDR files (they run 06:00 → 06:00). Calls already in the billing database are never saved twice.{checkOnly ? " Check only — nothing was saved." : ""}</p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="border-b border-slate-100 text-left text-[11px] uppercase tracking-wide text-slate-500">
            <th className="px-5 py-2 font-semibold">Day (UTC)</th><th className="px-3 py-2 text-right font-semibold">Calls in WebCDR</th>
            <th className="px-3 py-2 text-right font-semibold">Already saved</th><th className="px-3 py-2 text-right font-semibold">{checkOnly ? "Would add" : "Added"}</th>
            <th className="px-3 py-2 font-semibold">Files</th><th className="px-3 py-2 font-semibold">Status</th></tr></thead>
          <tbody>{days.map((d) => (
            <tr key={d.day} className="border-b border-slate-50 text-xs" data-testid={`uc-day-${d.day}`}>
              <td className="px-5 py-2 font-medium text-slate-800">{d.day}</td>
              <td className="px-3 py-2 text-right font-mono tabular-nums">{num(d.rows)}</td>
              <td className="px-3 py-2 text-right font-mono tabular-nums text-slate-500">{num(d.duplicates)}</td>
              <td className="px-3 py-2 text-right font-mono font-semibold tabular-nums" data-testid={`uc-day-added-${d.day}`}>{num(checkOnly ? d.new : d.inserted)}</td>
              <td className="px-3 py-2 font-mono text-[11px] text-slate-500">{(d.files || []).join(" + ") || "—"}</td>
              <td className="px-3 py-2"><DayStatus d={d} /></td>
            </tr>))}</tbody>
        </table>
      </div>
    </Card>
  );
}
